import React, { Component } from "react";
import Button from '@material-ui/core/Button';

import {
    Route,
    Redirect,
} from "react-router-dom";

import * as NA from '../actions/NavbarActions';


const popup = (myUrl, local) => {

    const sep = (myUrl.indexOf('?') !== -1) ? '&' : '?';
    const url = `${myUrl}${sep}`;
    const authWindow = (local) ? window.open(url, '_blank') : window.location.assign(url);


    // --- Add event listener ---
    if (local) {
        const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        const eventer = window[eventMethod];
        const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

        const authPromise = new Promise((resolve, reject) => {

            eventer(messageEvent, (msg) => {

                if (msg.data) {
                    localStorage.setItem('db-oauth', msg.data);
                    authWindow.close();
                    resolve(msg.data);
                } else {
                    authWindow.close();
                    reject('Unauthorised');
                }
            }, false);
        });
        return authPromise;
    }
};


export const isAuthenticated = () => {
    return localStorage.getItem('db-oauth');
}


export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            isAuthenticated() ? (
                <Component {...props} />
            ) : (
                    <Redirect
                        to={{
                            pathname: "/login",
                            state: { from: props.location }
                        }}
                    />
                )
        }
    />
)

export class AuthButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        const authMessage = () => {
            if (this.props.loggedIn) {
                return (
                    <Button
                        primary='true'
                        name='login'
                        onClick={this.props.logOut}
                        variant='outlined'
                    >
                        Sign Out
                    </Button>
                )
            } else {
                return (
                    <Button 
                        primary="true" 
                        name="Login" 
                        onClick={this.props.logIn}
                        variant='outlined'
                    >
                            Sign In
                    </Button>
                )
            }
        }

        return (
            <div>
                {authMessage()}
            </div>
        )
    }
}

export default class Authentication extends Component {

    constructor(props) {
        super(props);
        this.state = {
            redirectToReferrer: false,
            authenticated: false,
            local: false,
        }
    }

    componentDidMount() {
        this.setState({ local: this.props.local })
        const oauth = localStorage.getItem('db-oauth');
        if (oauth) {
            this.setState({ authenticated: oauth })
        }
    }

    handleAuthenticated = (authenticated, redirectToReferrer) => {
        if(authenticated) {
            localStorage.setItem('db-oauth', authenticated);
        } else {
            localStorage.removeItem('db-oauth');
        }

        NA.updateAuthentication(authenticated);

        this.setState({ authenticated, redirectToReferrer });
        this.props.handleAuthenticated(authenticated);
        
    }

    authenticate = async () => {
        // const stageUrl = 'https://github.com/login/oauth/authorize?client_id=1e571b61e851c559e29c&redirect_uri=http://dj-defectboard.s3-website-us-west-2.amazonaws.com/sso&allow_signup=false&state=test&scope=repo'
        // const prodUrl = 'https://github.com/login/oauth/authorize?client_id=cbd223a1fdad2632b05f&redirect_uri=https://defect.mindtouch.io/sso&allow_signup=false&state=test&scope=repo'
        const stageUrl = 'https://github.com/login/oauth/authorize?client_id=6ab772893813cd325a0e&redirect_uri=http://dan-defect-board-stage.s3-website-us-west-2.amazonaws.com/sso&allow_signup=false&state=test&scope=read:user'
        const prodUrl = 'https://github.com/login/oauth/authorize?client_id=b42ff85e28b9153d7348&redirect_uri=https://defect.mindtouch.io/sso&allow_signup=false&state=test&scope=read:user'
        const url = (this.props.environment === 'production') ? prodUrl : stageUrl;
        const accessToken = await popup(url, this.state.local)
        this.handleAuthenticated(accessToken, true)
    }

    signout = () => {
        this.handleAuthenticated(false, false);
    }

    render() {
        window.oa = this.state;
        window.oap = this.props;

        const { from } = this.props.location.state || { from: { pathname: "/" } };
        const { redirectToReferrer } = this.state;

        if(redirectToReferrer) {
            return (
                <Redirect to={from}/>
            )
        }

        return (
            <AuthButton 
                local={false} 
                loggedIn={this.state.authenticated} 
                logIn={this.authenticate.bind(this)} 
                logOut={this.signout.bind(this)}
            ></AuthButton>
        );
    }
}


// WEBPACK FOOTER //
// ./src/js/components/Authentication.js